<template>
    
      <v-autocomplete
        rounded
        dense
        solo
        v-model="value"
        :label="label"
        :items="values"
        :search-input.sync="search"
        @change="selectHandler"
        :required="ifRequired"
        :error-messages="errorMessage"
        :error="error"
        :loading="$apollo.loading"
        item-text="text"
        item-value="val" 
      >
      </v-autocomplete>

</template>

<script>
    
  export default {


    
    name: 'AutocompleteAsync',

    props: [
      "label",
      "name",
      "defaultValue",
      "ifRequired",
      "errorMessage",
      "error",
      "graphqlqueryProps",
      "graphqlqueryStringProps"
    ],

    data: function() {
      return({
        value: this.defaultValue,
        valueSearch: null,
        values: this.defaultValue ? [this.defaultValue] : [],
        skipQuery: true,
        search: null,
        graphqlquery: this.graphqlqueryProps,
        graphqlqueryString: this.graphqlqueryStringProps
      })      
    },

    watch: {
      search (val) {
        if(val){ 
           val && val !== this.value && this.getValues(val);
          }
      },
    },

    methods: {

      getValues (searchValue) {
        //console.log(this.value)
        if(searchValue.length > 1){
          this.skipQuery = false;
          this.valueSearch = searchValue   
        }
        
        if(searchValue.length == 0){
          this.skipQuery = true; //Disable query if value is null.
          this.$emit('change',null)
        }
      },

      handleBlur (event) {
            this.$emit('blur', event)
      },

      selectHandler() {
        this.skipQuery = true; //Disable query searche very time option is selected
        this.$emit('input', this.value)
      },
    },

    apollo: {
      // Query with parameters
      values: {

        query(){
          return this.graphqlquery 
        } ,
        // Reactive parameters
        variables () {
          // Use vue reactive properties here
          return {
            val: this.valueSearch,
          }
        },
        update: function(data){
          return data[this.graphqlqueryString]
        },
        // Disable the query
        skip () {
          return this.skipQuery
        },
      

      },
    }

  }
</script>

<style>

</style>